import { render, staticRenderFns } from "./UserAreaEdit.vue?vue&type=template&id=32c45fe2&scoped=true"
import script from "./UserAreaEdit.vue?vue&type=script&lang=js"
export * from "./UserAreaEdit.vue?vue&type=script&lang=js"
import style0 from "./UserAreaEdit.vue?vue&type=style&index=0&id=32c45fe2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c45fe2",
  null
  
)

export default component.exports